import { getChatbotConfig } from "../utils/utils";

/**
 * セッション管理サービス
 */
class SessionManager {
  private sessionKey: string | null = null;

  constructor() {
    // localStorageからセッションを復元
    this.restoreSession();
  }

  /**
   * localStorageからセッションをクリア
   * @returns セッションをクリア
   */
  private clearLocalStorage(): void {
    try {
      const config = getChatbotConfig();
      const chatbotId = config.chatbot_id;

      localStorage.removeItem(`chatbot_session_${chatbotId}`);
    } catch (error) {
      console.warn("localStorageをクリア失敗:", error);
    }
  }

  /**
   * localStorageからセッションを復元
   * @returns セッションを復元
   */
  private restoreSession(): void {
    try {
      const config = getChatbotConfig();
      const chatbotId = config.chatbot_id;

      const savedSession = localStorage.getItem(`chatbot_session_${chatbotId}`);

      if (savedSession) {
        this.sessionKey = savedSession;
      }
    } catch (error) {
      console.warn("セッション復元に失敗:", error);
      this.clearLocalStorage();
    }
  }

  /**
   * セッション情報を設定
   * @param sessionKey セッションキー
   * @param chatbot_id チャットボットID
   * @returns セッションを設定
   */
  setSession(sessionKey: string, chatbot_id: string): void {
    this.sessionKey = sessionKey;
    // localStorageに保存
    try {
      localStorage.setItem(`chatbot_session_${chatbot_id}`, sessionKey);
    } catch (error) {
      console.warn("セッションをlocalStorageに保存失敗:", error);
    }
  }

  /**
   * 現在のセッションキーを取得
   * @returns セッションキー
   */
  getSessionKey(): string | null {
    return this.sessionKey;
  }

  /**
   * セッション情報をクリア
   * @returns セッションをクリア
   */
  clearSession(): void {
    this.sessionKey = null;
    this.clearLocalStorage();
  }

  /**
   * セッションが有効かどうかを確認
   * @returns セッションが有効かどうか
   */
  isSessionValid(): boolean {
    return this.getSessionKey() !== null;
  }
}

export const sessionManager = new SessionManager();
